import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const ClassContext = createContext();

export const ClassProvider = ({ children }) => {
  const [classId, setClassId] = useState(null);

  return (
    <ClassContext.Provider value={{ classId, setClassId }}>
      {children}
    </ClassContext.Provider>
  );
};

ClassContext.propTypes={
  children:PropTypes.any
};

export const useClassContext = () => useContext(ClassContext);